module.exports = __webpack_public_path__ + "img/46800.3fba490c.jpg";